define(function (require) {
    "use strict";

    var LE = require("app");
    var DateUtility = require("utils/DateUtility");

    var CampaignListComparators = [];

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        CampaignListComparators = [
            {
               name:"name",

               func:function(model){
                   return model.getName().toLowerCase();
               }
            },
            {
                name:"status",

                func:function(model){

                    return model.getEnabledState()?1:2;
                }
            },
            {
                name:"statusMultiple",

                func:function(model){

                    return LE.translator.translate("LEContent.content.contentTable.status." + model.getStatusState());
                }
            },
            {
                name:"hotkeys",

                func:function(model){
                    var hotkeyObject = model.getContentHotkeys();
                    var returnString = "";
                    if (hotkeyObject !== undefined) {
                        returnString = hotkeyObject.prefix + hotkeyObject.suffix;
                    }
                    return returnString;
                }
            }
        ];
    });

    return CampaignListComparators;
});
